import { HttpRequest } from '../../../utils/httpClient';
import { AUTH_PATHS } from '../constants';
import config from '../../../config';

export const request = new HttpRequest(config.endpoints.auth);
export const userRequest = new HttpRequest(config.endpoints.users);

export const authService = {
  login: async (credentials) => {
    const response = await request.post(credentials, AUTH_PATHS.LOGIN);
    if (response.status === 200) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Error logging in');
  },
  
  validateToken: async (token) => {
    try {
      const headers = {
        'Authorization': `Bearer ${token}`
      };
      const response = await request.get(AUTH_PATHS.VALIDATE, {}, headers);
      return response.status === 200;
    } catch (error) {
      return false;
    }
  },
  
  getUser: async (token) => {
    const headers = {
      'Authorization': `Bearer ${token}`
    };
    const response = await request.get(AUTH_PATHS.USER, {}, headers);
    if (response.status === 200) {
      return response.data.data;

    }
    throw new Error(response.data?.message || 'Error retrieving user data');
  },

  getUserDetails: async (email, token) => {
    try {
      const headers = {
        'Authorization': `Bearer ${token}`
      };

      // Use userRequest instead of request (user endpoint, not auth endpoint)
      const response = await userRequest.get(`find/${email}`, {}, headers);

      if (!response) {
        throw new Error('No response from server');
      }

      if (response.status === 200 || response.status === 201) {
        // Backend returns data in response.data.body, not response.data.data
        const userData = response.data.body || response.data.data || response.data;
        return userData;
      }

      throw new Error(response.data?.message || 'Error retrieving user details');
    } catch (error) {
      throw error;
    }
  }
}; 